import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
export default function Footer({
  backcolor,
  setbackcolor,
search,
setsearch,
  border,
  setborder,
}) {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        height: "15%",
        margin: "0",
        background: `${backcolor}`,
        alignItems: "center",
        color: `white`,
        direction: "rtl",
        border: `2px solid ${border}`,
        boxShadow: ` 0 15px ${border},inset 0 0 15px ${border}`,
      }}
    >
      <FormControlLabel
        control={<Switch defaultChecked />}
        
        label={<span style={{fontSize:"40px"}}>Night Mode</span>}
        style={{ marginRight: "40px" }}
        onChange={() => {
          backcolor === "#0b0f14"
            ? setbackcolor("#3b444fff")
            : setbackcolor("#0b0f14");
         backcolor=== "#0b0f14"? setborder("#0b0f14"): setborder("#00e5ff") ;

        }}
      />
      <div
        style={{
          background: `${backcolor}`,
          border: `2px solid ${border}`,
          borderRadius: "10px",
          width: "40%",
          height: "30%",
          direction: "ltr",
          padding: "0 ",
          justifyContent: "space-between",
          color: `white`,
          display: "flex",
          margin: "100px",
        }}
      >
        <IconButton>
          <SearchIcon fontSize="large" color="primary"></SearchIcon>
        </IconButton>
        <input
        value={search}
        onChange={(e)=>{setsearch(e.target.value)}}
          type="text"
          placeholder="Search by Icao24 for the Plane"
          style={{
            background: `${backcolor}`,
            height: "90%",
            width: "100%",
            margin: "0",
            fontSize:"20px",
            direction: "ltr",
            padding: "0 30px",
            color: `white`,
            borderRadius: "0px 10px 10px 0px",
          }}
        ></input>
      </div>
    </div>
  );
}
